import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import ImageLoader from "../common/ImageLoader";
import { useIsMobile } from "../../hooks";

const Carousel = ({ carouselData }) => {
  const isMobile = useIsMobile(769);

  const [isSliderInitialized, setIsSliderInitialized] = useState(false);
  const [progress, setProgress] = useState(-100);
  const [currentSlide, setCurrentSlide] = useState(0);
  const backgroundType = carouselData[currentSlide].backgroundType;

  const handleBeforeChange = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    if (!isSliderInitialized) return;
    setProgress(-100);

    const interval = setInterval(() => {
      setProgress((prev) => (prev >= 0 ? -100 : prev + 1));
    }, 60);

    const handleResize = () => {
      setProgress(-100);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", handleResize);
    };
  }, [isSliderInitialized, currentSlide]);

  const settings = {
    fade: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false,
    vertical: true,
    verticalSwiping: true,
    beforeChange: (_, next) => handleBeforeChange(next),

    onInit: () => {
      setIsSliderInitialized(true);
    },
  };

  return (
    <>
      {!isMobile && (
        <section
          className={`technology-carousel technology-carousel--desktop technology-carousel--${backgroundType}`}
        >
          <div className="container">
            <Header
              title={carouselData[currentSlide].title}
              description={carouselData[currentSlide].description}
            />
          </div>
          <div
            className="technology-carousel__items"
            style={{ "--progress": `${progress}%` }}
          >
            <Slider {...settings}>
              {carouselData.map(
                (
                  {
                    image: {
                      src,
                      alt,
                      width,
                      height,
                      srcMobile,
                      widthMobile,
                      heightMobile,
                    },
                    title,
                    description,
                  },
                  index
                ) => (
                  <SlideItem
                    isMobile={isMobile}
                    alt={alt}
                    width={width}
                    height={height}
                    src={src}
                    srcMobile={srcMobile}
                    widthMobile={widthMobile}
                    heightMobile={heightMobile}
                    title={title}
                    description={description}
                    key={index}
                  />
                )
              )}
            </Slider>
          </div>
        </section>
      )}
      {isMobile &&
        carouselData.map(
          (
            {
              backgroundType,
              image: {
                src,
                alt,
                width,
                height,
                srcMobile,
                widthMobile,
                heightMobile,
              },
              title,
              description,
            },
            index
          ) => (
            <section
              className={`technology-carousel technology-carousel--mobile technology-carousel--${backgroundType}`}
            >
              <SlideItem
                isMobile={isMobile}
                alt={alt}
                width={width}
                height={height}
                src={src}
                srcMobile={srcMobile}
                widthMobile={widthMobile}
                heightMobile={heightMobile}
                title={title}
                description={description}
                key={index}
              />
            </section>
          )
        )}
    </>
  );
};

function Header({ title, description }) {
  return (
    <div className="technology-carousel__header">
      {title && <h2 className="technology-carousel__header-title">{title}</h2>}
      {description && (
        <div className="technology-carousel__header-description">
          {description()}
        </div>
      )}
    </div>
  );
}
function SlideItem({
  isMobile,
  src,
  srcMobile,
  alt,
  width,
  height,
  widthMobile,
  heightMobile,
  title,
  description,
}) {
  return (
    <div className="technology-carousel__item">
      <Header title={title} description={description} />
      <ImageLoader
        className="technology-carousel__item-image"
        image={src}
        smallImage={srcMobile}
        alt={alt}
        height={isMobile ? heightMobile : height}
        width={isMobile ? widthMobile : width}
        placeholderAspectRatio={
          isMobile ? widthMobile / heightMobile : width / height
        }
        noLazyLoad
      />
    </div>
  );
}

export default Carousel;
